import React, { useState, useEffect, useContext } from 'react';
import {
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  IconButton,
  TableContainer,
  Grid,
  CircularProgress,
  Backdrop,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import MUIDataTable from 'mui-datatables';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import { Link, useNavigate } from 'react-router-dom';
import Scrollbar from 'src/components/scrollbar';
import Iconify from '../../../iconify';
// import download from 'downloadjs';
import toast from 'react-hot-toast';
import { AuthContext } from 'src/context/AuthContext';
// mock
const { PRIVATE_ROUTE } = API_ROUTES;

export default function ManagerInvoiceList() {
  const { state } = useContext(AuthContext);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(null);
  const { authAxios } = useContext(FetchContext);
  const [showloading, setshowLoading] = useState(false);
  const [sortEnable, setSortEnable] = useState({});
  const [searchEnable, setSearchEnable] = useState();
  const navigate = useNavigate();

  const handleDownload = async (id) => {
    setshowLoading(true);
    await authAxios.get(`${PRIVATE_ROUTE?.GENERATE_TOKEN}/${id}`, { responseType: 'blob' }).then((response) => {
      const content = response.headers['content-type'];
      download(response.data, id + '.pdf', content);
      setshowLoading(false);
    });
    getInvoicedata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: page,
    });
  };

  const handlecreateform = () => {
    navigate('/manager/invoice/create');
  };

  const handlePaymentRecived = async (item) => {
    if (confirm('Confirm if the payment process has been completed successfully.')) {
      try {
        const response = await authAxios.get(`${PRIVATE_ROUTE?.GET_INVOICE_PAYMENT_RECEIVED}?id=${item._id}`);
        if (response.status === 200) {
          setLoading(true);
          getInvoicedata('');
        }
      } catch (error) {
        console.error('Error updating payment status:', error);
        alert('An error occurred while updating the payment status. Please try again.');
      }
    }
  };

  const getInvoicedata = (query) => {
    let sort_params;
    let page_cout = query.page_no ? query.page_no : 0;
    let search_query = query.searchQuery ? query.searchQuery : '';
    let sortField = query.sortField ? query.sortField : sortEnable.sortField;
    let sortOrder = query.sortOrder ? query.sortOrder : sortEnable.sortOrder;
    if (typeof query !== 'string') {
      sort_params = `&sortField=${sortField}&sortOrder=${sortOrder}&search=${search_query}`;
    } else {
      sort_params = `&search=${query}`;
    }
    let isMounted = true;
    const getInvoices = async () => {
      const { data } = await authAxios.get(
        `${PRIVATE_ROUTE?.GET_INVOICE}?page=${page_cout + 1}&per_page=${rowsPerPage}${sort_params}&user_id=${state.user._id
        }`
      );
      if (isMounted) {
        setInvoices(
          data?.data?.map((item) => {
            return {
              _id: item._id,
              generated_date: new Date(item?.generated_date).toISOString().split('T')[0],
              invoice_number: item?.number?.toString().padStart(6, '0'),
              client_number:
                item.client_id.company_name,
              tasks: (
                <Link to={`/manager/task/view/${item.task_details._id}`}>
                  <b>{item.task_details.number_str}</b>
                </Link>
              ),
              jobs: (
                <Link to={`/manager/job/view/${item.job_details._id}`}>
                  <b>{item.job_details.number_str}</b>
                </Link>
              ),
              payment_status: item.is_paid === 0 ? 'Unpaid' : 'Paid',
              doc_number: item.doc_number ? item.doc_number : '-',
              is_payment_receive:
                item.is_paid === 0 ? (
                  <Button variant="contained" onClick={(e) => handlePaymentRecived(item)}>
                    Receive Payment
                  </Button>
                ) : (
                  '-'
                ),

              invoice_amt: item?.sub_total ? item?.sub_total : item.total_cost,
              qb_invoice_id: item?.qb_invoice_id,
              SyncToken: item?.SyncToken,
            };
          })
        );
        setCount(data.total);
        setLoading(false);
      }
    };

    getInvoices().catch((err) => {
      if (!isMounted) return;
      console.error('failed to fetch data', err);
      setLoading(false);
    });
    return () => {
      isMounted = false;
    };
  };
  const handleRowDelete = async (e, id, qb_invoice_id, SyncToken) => {
    const data = {
      Id: id,
      qb_invoice_id: qb_invoice_id,
      SyncToken: SyncToken,
    };
    if (confirm('Are you sure want to delete?') === true) {
      const response = await authAxios.post(PRIVATE_ROUTE.DELETE_INVOICE, data);
      if (response.data.statusCode === 200) {
        toast.success(response.data.massage);
      } else {
        toast.error(response.data.massage);
      }
      setLoading(false);
      getInvoicedata('');
    }
  };

  const handleEditRedirect = (e, invoice_id) => {
    navigate(`/manager/invoice/update/${invoice_id}`);
  };

  useEffect(() => {
    if (rowsPerPage * page < count) {
      getInvoicedata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
      });
    } else {
      getInvoicedata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
      });
    }
    setLoading(true);
  }, [rowsPerPage]);

  const columns = [
    {
      name: '_id',
      label: 'Id',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: false,
      },
    },
    {
      name: 'qb_invoice_id',
      label: 'qb_invoice_id',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: false,
      },
    },
    {
      name: 'SyncToken',
      label: 'SyncToken',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: false,
      },
    },
    // {
    //   name: '',
    //   label: '',
    //   options: {
    //     draggable: true,
    //     sort: false,
    //     filter: true,
    //     display: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <>
    //           <IconButton color="inherit" onClick={(e) => handleDownload(tableMeta.rowData[1])}>
    //             <Iconify width={15} icon={'eva:download-outline'} />
    //           </IconButton>
    //         </>
    //       );
    //     },
    //   },
    // },
    {
      name: 'invoice_number',
      label: 'Invoice',
      options: {
        draggable: false,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'client_number',
      label: 'Client Name',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'tasks',
      label: 'Task Number',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'jobs',
      label: 'Job Number',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'doc_number',
      label: 'QB Invioce #',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'invoice_amt',
      label: 'Invoice amount',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },

    {
      name: 'generated_date',
      label: 'Date Generated',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'payment_status',
      label: 'Payment Status',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'is_payment_receive',
      label: 'Payment',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },

    {
      name: '',
      lable: 'Action',
      options: {
        filter: false,
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const isPaid = tableMeta.rowData[11] === 'Paid';
          return (
            <div style={{ display: 'flex', gap: '5px' }}>
              <span style={{ opacity: isPaid ? 0.5 : 1, pointerEvents: isPaid ? 'none' : 'auto' }}>
                <EditIcon onClick={(e) => !isPaid && handleEditRedirect(e, tableMeta.rowData[0])} />
              </span>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    selectToolbarPlacement: 'none',
    search: true,
    searchOpen: true,
    tableId: 'HelloWorld',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standerd',
    filter: false,
    print: true,
    fixedHeader: true,
    count: count,
    selectableRows: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      const formattedData = data.map((item) => {
        if (typeof item === 'string') {
          return item;
        }
        if (typeof item === 'object' && Array.isArray(item.data)) {
          const result = [];

          item.data.forEach((el) => {
            if (typeof el !== 'object') {
              result.push(el);
            }

            if (typeof el === 'object') {
              if (el.props?.to) {
                result.push(el.props.children.props.children);
              }

              if (Array.isArray(el.props?.children)) {
                const childrenArray = el.props.children;

                const combinedString = `${childrenArray[1]}, ${childrenArray[5]}, ${childrenArray[9]}, ${childrenArray[13]}`;
                result.push(combinedString);

              }
            }
          });

          return result;
        }

        return null;
      });
      const result = formattedData.map((data, index) => ({
        index: index,
        data: data,
      }));

      return '\uFEFF' + buildHead(columns) + buildBody(result);
    },
    setRowProps: (row, dataIndex, rowIndex) => {
      return {
        style: {
          backgroundColor: rowIndex % 2 === 0 ? 'rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)' : 'white',
        },
      };
    },
    setTableProps: () => {
      return {
        padding: 'default',
        border: '1px solid rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)',
        size: 'small',
      };
    },
    onSearchChange: (searchQuery) => {
      setSearchEnable(searchQuery);
      if (searchQuery !== null && searchQuery.length > 2) {
        if (Object.keys(sortEnable).length !== 0) {
          const sortField = sortEnable.sortField;
          const sortOrder = sortEnable.sortOrder;
          getInvoicedata({ sortField, sortOrder, searchQuery });
        } else {
          getInvoicedata(searchQuery);
        }
        setLoading(true);
      }
      if (searchQuery === null) {
        if (Object.keys(sortEnable).length !== 0) {
          const sortField = sortEnable.sortField;
          const sortOrder = sortEnable.sortOrder;
          getInvoicedata({ sortField, sortOrder });
        } else {
          getInvoicedata('');
        }
        setLoading(true);
      }
    },
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },
    rowsPerPage: rowsPerPage,
    serverSide: true,

    onTableChange: (action, tableState) => {
      const { name, direction } = tableState.sortOrder;
      const sortField = name;
      const sortOrder = direction;
      let searchQuery = searchEnable;
      let page_no = tableState.page;
      if (action === 'sort') {
        setSortEnable({ sortField, sortOrder });
        if (searchEnable) {
          getInvoicedata({ sortField, sortOrder, searchQuery, page_no });
        } else {
          getInvoicedata({ sortField, sortOrder, page_no });
        }
        setLoading(true);
      }
      setPage(tableState.page);
      if (action === 'changePage') {
        if (searchEnable) {
          getInvoicedata({ sortField, sortOrder, searchQuery, page_no });
        } else {
          getInvoicedata({ sortField, sortOrder, page_no });
        }
        setLoading(true);
      }
    },
  };

  return (
    <>
      <Grid sx={{ maxWidth: 1500, margin: 'auto' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h4" gutterBottom>
            Invoice
          </Typography>
          <Button variant="contained" onClick={handlecreateform} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Invoice
          </Button>
        </Stack>
        <Grid>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <MUIDataTable options={options} columns={columns} data={invoices} />
                {showloading ? (
                  <div>
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={showloading}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  </div>
                ) : (
                  ''
                )}
                {loading && (
                  <div>
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  </div>
                )}
                {!invoices && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Grid>
      </Grid>
    </>
  );
}
